import React, { useState } from 'react';
import { useTranslate } from '@bynder/localization';
import useThunkDispatch from 'packages/hooks/useThunkDispatch';
import { Template } from 'packages/store/templates/types';
import { EntityType } from 'packages/store/sharing/types';
import ShareModal from '.';
import useAccessRights from 'packages/hooks/useAccessRights';
import { ActiveSplits } from 'packages/store/user/types';
import { fetchSharing } from 'packages/store/sharing/sharing.actions';

type Params = { collectionName?: string };

const useTemplateShareModal = ({ collectionName }: Params) => {
    const [shareModalTemplate, setShareModalTemplate] = useState<Template | null>(null);
    const { translate } = useTranslate();
    const { isSplitEnabled } = useAccessRights();
    const isMultipleCategoriesEnabled = isSplitEnabled(ActiveSplits.studioMultipleTemplateCategories);

    const dispatch = useThunkDispatch();

    const showModal = shareModalTemplate !== null;

    const onClose = () => {
        if (shareModalTemplate) {
            dispatch(fetchSharing(shareModalTemplate.id, EntityType.TEMPLATE));
        }

        setShareModalTemplate(null);
    };

    const renderModalTemplateShare = () => (
        <ShareModal
            title={translate('modal.template.share.title')}
            entityId={shareModalTemplate && shareModalTemplate.id}
            entityType={EntityType.TEMPLATE}
            isModalOpen={showModal}
            collectionName={collectionName ?? (showModal ? shareModalTemplate?.categoryName : null)}
            categories={isMultipleCategoriesEnabled ? shareModalTemplate?.categories : undefined}
            onClose={onClose}
        />
    );

    return {
        setShareModalTemplate,
        renderModalTemplateShare,
    };
};

export default useTemplateShareModal;
